import dayjs from 'dayjs'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useAejOutletContext } from 'pages/GerarAej.context'
import { useParams } from 'react-router-dom'
import { aej } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirAEJ() {
    const { id } = useParams()
    const { data } = useAejOutletContext()
    const item = data.find(item => item.id === id)

    const { mutateAsync, isLoading } = aej.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!item) return null

    const handleSubmit = () =>
        mutateAsync(item.id as any, {
            onSuccess: () => {
                toast.success('Relatório excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'AEJ']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir o arquivo AEJ de{' '}
                    {dayjs.utc(item.createdAt).format('LL')}?
                </>
            }
        />
    )
}
